<input class="input"
        type="text"
        class="no-margin-bottom"

        [(ngModel)]="autocompleteInput"
        #addresstext 
        
        >